import React, { useMemo } from 'react'

export const COLOR_THEME = [
  '#8CC63F',
  '#60AC66',
  '#419982',
  '#1D83A2',
  '#1868A6',
  '#135182',
  '#003863',
  '#a9d46f',
  '#9bd49f',
  '#71b3a1',
  '#56a2b9',
  '#528ebc',
  '#4e7da1',
  '#406a8a',
  '#c6e39f',
  '#bce2bf',
  '#a0ccc1',
  '#8ec1d1',
  '#8cb4d3',
  '#89a8c1',
  '#809cb1'
] as const

export const Arm: React.FC<{
  onDelete: () => void
  showDelete: boolean
  rank: number
  showRank: boolean
  className: string
}> = props => {
  const click = () => {
    if (props.onDelete) props.onDelete()
  }

  const style = useMemo(() => {
    const color = props.rank ? COLOR_THEME[(props.rank - 1) % COLOR_THEME.length] : '#cccccc'
    return { backgroundColor: color }
  }, [props.rank])

  const deleteControl = props.showDelete ? (
    <div className={`${props.className} ${props.className}-delete`} onClick={click}>
      <i className={`icon-aytmfd-delete ${props.className}-delete-icon`}></i>
    </div>
  ) : null

  const rankControl =
    props.showRank && props.rank > 0 ? (
      <div className={props.className} style={style}>
        <div className={`${props.className}-rank`}>{props.rank}</div>
      </div>
    ) : null

  return props.showRank && props.rank > 0 ? (
    <>
      {rankControl}
      {deleteControl}
    </>
  ) : (
    deleteControl
  )
}

export default Arm
